export const STATUS = {
  RELEASED: 'released',
  HELD: 'held',
};

export const MODAL_RELEASE_TEXT = 'Do you want to release the study to the tester platform?';
export const MODAL_HELD_TEXT = 'Do you want to HOLD the study?';

export const STATUS_INDEXED = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};
